import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { AdornedInput, Input, Adornment, IconSearch } from '@zillow/constellation';
import React from 'react';

var _excluded = ["_handleAddressSelect", "_addressSelected", "_onTagClose", "_onClear", "_options"];
var PLACEHOLDER_TEXT = 'Enter your home address';
var SearchInputWithButton = function SearchInputWithButton(_ref) {
  _ref._handleAddressSelect;
    _ref._addressSelected;
    _ref._onTagClose;
    _ref._onClear;
    _ref._options;
    var props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(AdornedInput, {
    input: /*#__PURE__*/React.createElement(Input
    // id={undefined} prevents chrome autocomplete display
    , _extends({
      id: undefined,
      placeholder: PLACEHOLDER_TEXT
    }, props)),
    rightAdornment: /*#__PURE__*/React.createElement(Adornment, {
      "aria-hidden": "false"
    }, /*#__PURE__*/React.createElement(IconSearch, null))
  });
};
var SearchInputWithButton$1 = SearchInputWithButton;

export { PLACEHOLDER_TEXT, SearchInputWithButton$1 as default };
